import { useSelector } from 'react-redux';
/* ------------------------------------- MATERIAL UI --------------------------------------- */
import { Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';

export default function SubscriptionBillingForm() {
  const t = useTranslation();
  const session = useSelector(selectSession);

  return (
    <Stack spacing={3}>
      <Typography variant="h6" gutterBottom>
        {t('SPA_BillingAddress')}
      </Typography>

      <TextField
        fullWidth
        label={t('fields_FullName')}
        value={`${session.prenom} ${session.name}` || ''}
        InputProps={{ readOnly: true }}
      />

      <TextField
        fullWidth
        label={t('fields_Phone')}
        value={session.phone || ''}
        InputProps={{ readOnly: true }}
      />

      <TextField
        fullWidth
        label={t('fields_Email')}
        value={session.email || ''}
        InputProps={{ readOnly: true }}
      />

      <TextField
        fullWidth
        label={t('fields_Address')}
        value={session.adresse || ''}
        InputProps={{ readOnly: true }}
      />
    </Stack>
  );
}
